import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 short sessions",
    focus: "Throwing, catching, batting contact, bowling rhythm, fielding games",
    weeklyHabit: "Keep drills simple and rotate skills often",
  },
  {
    level: "Developing player",
    frequency: "3 sessions plus match",
    focus: "Batting basics, bowling consistency, catching, ground fielding",
    weeklyHabit: "Use one batting, one bowling, and one fielding focus each week",
  },
  {
    level: "Competitive player",
    frequency: "3 to 5 sessions plus match",
    focus: "Scenario batting, bowling plans, wicketkeeping or fielding roles, fitness",
    weeklyHabit: "Review match situations and train one decision from the game",
  },
  {
    level: "Advanced player",
    frequency: "5 sessions with recovery",
    focus: "Role-specific skills, strength, speed, tactical plans, workload management",
    weeklyHabit: "Track bowling loads, gym work, nets, matches, and rest",
  },
]

const sections = [
  {
    title: "Beginner: rotate skills often",
    paragraphs: [
      "Beginner cricket training should move between throwing, catching, batting contact, bowling rhythm, and fielding games. Short stations keep energy high.",
      "Technical advice should be simple. Young players need lots of successful catches, clean hits, and smooth bowling attempts before adding too many details.",
    ],
  },
  {
    title: "Developing player: build reliable basics",
    paragraphs: [
      "Developing players can split the week into batting, bowling, and fielding focuses. Batting might include straight contact and calling; bowling might include run-up rhythm and line; fielding might include clean pickup and throw.",
      "Wicketkeepers and bowlers may need extra care with workload, especially when training and matches stack together.",
    ],
  },
  {
    title: "Competitive player: train match scenarios",
    paragraphs: [
      "Competitive cricket practice should include scenario batting, bowling plans, field placements, catching under pressure, and role-specific fitness.",
      "A useful session might train one game moment: chasing a total, bowling at the death, rotating strike, or attacking a new batter.",
    ],
  },
  {
    title: "Advanced player: manage workload",
    paragraphs: [
      "Advanced players need nets, fielding, strength, speed, mobility, tactical review, and recovery. Fast bowlers especially need workload tracking.",
      "A shared calendar helps coordinate club training, school matches, rep cricket, gym work, and rest so the player is not overloaded without anyone noticing.",
    ],
  },
]

const CricketTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Cricket Training Schedule by Skill Level"
        description="Plan cricket training for beginners, developing players, competitive players, and advanced athletes with batting, bowling, fielding, fitness, and recovery routines."
      />
      <SportsTrainingPost
        sport="Cricket"
        title="Cricket training routines for different levels"
        intro="A good cricket routine balances batting, bowling, fielding, match scenarios, fitness, and workload management across the week."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/tall-sheep-99"
        image="blog-cricket.png"
        imageAlt="Cricket training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default CricketTrainingRoutines
